import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ContentDetailsPageSkeleton = () => (
  <section
    className="content-page content-details-page portal-page-skeleton"
    aria-label="Carregando detalhes do conteúdo"
    aria-busy="true"
  >
    <div className="content-details-page__inner">
      <div className="content-details-page__intro">
        <Skeleton width={88} height={28} />
        <header className="content-details-page__header">
          <Skeleton width="min(620px, 86vw)" height={40} />
          <Skeleton width={300} height={20} />
        </header>
      </div>

      <div className="content-details-page__main">
        <Skeleton className="content-details-skeleton__cover" height={480} />
        <div className="content-details-tabs" aria-hidden="true">
          <Skeleton width={76} height={28} />
          <Skeleton width={106} height={28} />
        </div>
        <div className="content-details-about">
          <Skeleton width={230} height={30} />
          <Skeleton count={4} />
        </div>
      </div>

      <aside className="content-details-skeleton__panel" aria-hidden="true">
        <Skeleton width="70%" height={28} />
        <Skeleton height={10} />
        <Skeleton count={5} height={48} />
      </aside>
    </div>
  </section>
);

export default ContentDetailsPageSkeleton;
